import { FF_BRAZE_CONTENT_CARDS } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import { CircularProgress } from '@montugroup/design-system';
import { alternaleaf } from '@montugroup/themes';
import { useMediaQuery } from '@mui/material';
import { Suspense } from 'react';
import { BrazePageMessaging } from '../braze/BrazePageMessaging';
import AlertSnackbarProvider from '../error/AlertSnackbarProvider';
import { ContentWrapper, MainContentBox, PageContentWrapper } from './PageLayout.styles';
import MobileAppBar from './navbar/MobileAppBar';
import Sidebar from './sidebar/Sidebar';

export const PageLayout = ({ children }: { children: React.ReactNode }) => {
  const isLargeView = useMediaQuery(alternaleaf.breakpoints.up('md'));
  const { flags } = useFeatureFlags();

  return (
    <MainContentBox>
      <AlertSnackbarProvider>
        {isLargeView ? <Sidebar /> : <MobileAppBar />}
        <PageContentWrapper>
          {flags[FF_BRAZE_CONTENT_CARDS] && <BrazePageMessaging />}
          <ContentWrapper>
            <Suspense fallback={<CircularProgress />}>{children}</Suspense>
          </ContentWrapper>
        </PageContentWrapper>
      </AlertSnackbarProvider>
    </MainContentBox>
  );
};
